const componentStyles = {
  buttonWidth: '300px',
  selectFieldWidth: '600px',
  textFieldWidth: '600px'

};

export default componentStyles;